import Toggle from "@ingka/toggle";

import "@ingka/toggle/dist/style.css";

type FixaToggleButton = {
  text?: string;
  ssrIcon?: (prefix?: string) => React.SVGProps<SVGElement>[];
  disabled?: boolean;
};

type FixaToggleProps = {
  buttons: FixaToggleButton[];
  activeIndex?: number;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>, index: number) => void;
  className?: string;
};

function FixaToggle(props: FixaToggleProps) {
  return <Toggle {...props} />;
}

export default FixaToggle;
